module.exports = "## A Simple Image Editor Without Complexity\r\n\r\nAdd filters, crop, resize, or flip & rotate your images with ease"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/PhotoEditor/photo-editor-header.md
// module id = 1162
// module chunks = 0